"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findKey = void 0;
function findKey(subject, predicate, thisArg) {
    return Object.keys(subject).find(function (k, i, a) {
        return predicate.apply(this, [k, i, a, subject]);
    }, thisArg);
}
exports.findKey = findKey;
//# sourceMappingURL=findKey.js.map